import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { Dropdown } from "@/components/sidebar/Dropdown";
import { useTableEditorState } from "@/components/tiptap/selectors/useTableEditorState";

import type { DocumentModel } from "@/models/DocumentModel";

type Props = {
  doc: DocumentModel;
  className?: string;
};

export function TableBordersDropdown({ doc, className }: Props) {
  const t = useTranslations("sidebar.tableStyle");
  const { tiptap } = doc.editor;
  const { showHorizontalLines, showVerticalLines } = useTableEditorState(doc) ?? {};

  if (!tiptap) {
    return null;
  }

  const items = [
    {
      title: t("bordersStyle.columnsGrid"),
      icon: <Icon name="ColumnsGrid" />,
      active: showVerticalLines,
      onClick: () => {
        tiptap.commands.updateAttributes("table", {
          showVerticalLines: !showVerticalLines,
        });
      },
    },
    {
      title: t("bordersStyle.rowsGrid"),
      icon: <Icon name="RowsGrid" />,
      active: showHorizontalLines,
      onClick: () => {
        tiptap.commands.updateAttributes("table", {
          showHorizontalLines: !showHorizontalLines,
        });
      },
    },
  ];

  return (
    <Dropdown
      className={className}
      toggleButtonComponent={<Sidebar.ToggleButton as="div" icon={<Icon name="BordersStyle" />} />}
      toggleButtonLabel={t("bordersStyle.buttonLabel")}
      items={items}
    />
  );
}
